var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({class:{
    'cta-button': true,
    'is-loading': _vm.loading,
    solid: _vm.solid,
    red: _vm.red,
    orange: _vm.orange,
    'full-width': _vm.fullWidth,
  },attrs:{"type":"button","disabled":_vm.loading},on:{"click":_vm.handleClick}},'button',Object.assign({}, _vm.$props),false),[(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }